<h2 class="text-center">AOV VERGELIJKER</h2>
<div class="row navigation-bar">
  <div class="col-sm-4 text-center">
    <a href="javascript:{}" *ngIf="currentIndex > 0" (click)="onVerzekerdeClick()">
      <figure class="figure done-step">
        <i class="nav-icon verzekering"></i>
        <figcaption class="figure-caption">gegevens</figcaption>
      </figure>
    </a>
    <figure class="figure current-step" *ngIf="currentIndex === 0">
      <i class="nav-icon verzekering"></i>
      <figcaption class="figure-caption">gegevens</figcaption>
    </figure>
  </div>
  <div class="col-sm-4 text-center">
    <a href="javascript:{}" *ngIf="currentIndex > 1" (click)="onAdviesClick()">
      <figure class="figure done-step">
        <i class="nav-icon advies"></i>
        <figcaption class="figure-caption">advies</figcaption>
      </figure>
    </a>
    <figure class="figure" [ngClass]="{'current-step': currentIndex === 1}"  *ngIf="currentIndex <= 1">
      <i class="nav-icon advies"></i>
      <figcaption class="figure-caption">advies</figcaption>
    </figure>
  </div>
  <div class="col-sm-4 text-center">
    <figure class="figure" [ngClass]="{'current-step': currentIndex === 2}" >
      <i class="nav-icon ontvangen"></i>
      <figcaption class="figure-caption">bevestiging</figcaption>
    </figure>
  </div>
</div>
